import React from 'react';
import PropTypes from 'prop-types';

const OUTPUT_OPTIONS = [
  {
    value: 'Plain Text',
    title: 'Plain Text',
    description: 'Natural language response without formatting.',
  },
  {
    value: 'Schema',
    title: 'JSON (Structured Data)',
    description: 'For data extraction and parsing. You\'ll define the schema next.',
  },
  {
    value: 'Markdown',
    title: 'Markdown',
    description: 'Formatted text with headers, lists, and styling.',
  },
  {
    value: 'XML',
    title: 'XML',
    description: 'Custom XML structure for integration.',
  },
  {
    value: 'CSV',
    title: 'CSV',
    description: 'Tabular data output for spreadsheets.',
  },
];

const StepOutputFormat = ({ formData, updateFormData, errors }) => {
  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>How should the AI respond?</h3>
        <p>Select the output format for your generated content.</p>
      </div>

      {errors?.output_type && (
        <div className="form-error-message">{errors.output_type}</div>
      )}

      <div className="radio-group">
        {OUTPUT_OPTIONS.map((option) => (
          <label 
            key={option.value} 
            className={`radio-card ${formData.output_type === option.value ? 'selected' : ''}`}
          >
            <input
              type="radio"
              name="output_type"
              value={option.value}
              checked={formData.output_type === option.value}
              onChange={(e) => updateFormData('output_type', e.target.value)}
            />
            <div className="radio-content">
              <span className="radio-title">{option.title}</span>
              <span className="radio-description">{option.description}</span>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

StepOutputFormat.propTypes = {
  formData: PropTypes.shape({
    output_type: PropTypes.string,
  }).isRequired,
  updateFormData: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

StepOutputFormat.defaultProps = {
  errors: {},
};

export default StepOutputFormat;
